import {
	CRITERION_USTAV,
	MATRIX_USTAV,
	NUMBERS_USTAV,
	SOLE_EXECUTIVE_BODY,
	TRANSLATE_NUMBER_USTAV,
} from 'Pages/registratorCabinet'

export const calcUstav = (shablon: Record<CRITERION_USTAV, boolean | SOLE_EXECUTIVE_BODY>) => {
	const activeUstavs = {}
	Object.keys(MATRIX_USTAV).forEach((nunmberUstav) => {
		activeUstavs[nunmberUstav] = true
		Object.keys(shablon).forEach((criterionUstav) => {
			if (
				shablon[criterionUstav] &&
				MATRIX_USTAV[nunmberUstav][criterionUstav] !== shablon[criterionUstav]
			) {
				activeUstavs[nunmberUstav] = false
			}
		})
	})
	return activeUstavs as Record<Partial<NUMBERS_USTAV>, boolean>
}

export const keysNumberUstav = Object.values(NUMBERS_USTAV).filter(
	(item) => typeof item === 'string'
)

export const optionsUstav = keysNumberUstav.map((key) => {
	return { id: NUMBERS_USTAV[key], name: TRANSLATE_NUMBER_USTAV[NUMBERS_USTAV[key]] }
})
